module.exports = __webpack_public_path__ + "static/media/logo_logs.421ad71e.png";